import React from 'react';
import { default as MainHeader } from '../../../components/Header';
import Overview from './Overview';
import { useHistory } from 'react-router-dom';
import { routes } from '../../data/constants';
import Header from './Header';

const Dealerships = () => {
  let history = useHistory();

  const handleBack = () => {
    history.push(routes.HOME);
  };

  return (
    <div className='builder-flex builder-flex-1 builder-flex-col builder-h-screen builder-font-body builder-text-sm'>
      <MainHeader />

      <Header title='Dealerships overview' onBack={handleBack} />

      <div className='builder-flex builder-items-center builder-justify-center builder-bg-white builder-px-4'>
        <div className='builder-container'>
          <Overview />
        </div>
      </div>
    </div>
  );
};

export default Dealerships;
